import React, { Component } from 'react';
import './PaginationComponent.css';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import _ from 'lodash';

const PREVIOUS = "pervious";
const NEXT = "next";

class PaginationComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current: null,
            total: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.current) && !_.isNil(nextProps.total) && (this.state.current !== nextProps.current || this.state.total !== nextProps.total)) {
            this.setState({
                current: nextProps.current,
                total: nextProps.total
            })
        }
    }

    render() {
        if (_.isNil(this.state.current) || _.isNil(this.state.total) || this.state.total <= 1) {
            return null;
        }

        return (
            <div className='pagination-container'>
                <Pagination>
                    <PaginationItem disabled={this.state.current === 0}>
                        <PaginationLink previous onClick={this.handleClickNavigation(PREVIOUS)} />
                    </PaginationItem>
                    {this.getPaginationItems()}
                    <PaginationItem disabled={this.state.current === this.state.total - 1}>
                        <PaginationLink next onClick={this.handleClickNavigation(NEXT)} />
                    </PaginationItem>
                </Pagination>
            </div>
        );
    }

    getPaginationItems = () => {
        let items = [];
        for (let i = 0; i < this.state.total; i++) {
            let active = this.state.current === i;

            items.push(
                <PaginationItem active={active} key={"pagination-item-" + i}>
                    <PaginationLink onClick={this.handleClickPage(i)}>
                        {i + 1}
                    </PaginationLink>
                </PaginationItem>
            )
        }

        return items;
    }

    handleClickPage = (id) => () => {
        id = parseInt(id, 10);
        if (Number.isInteger(id) && this.state.current !== id) {
            this.props.getDataForPage(id);
            this.setState({ current: id });
        }
    };

    handleClickNavigation = (id) => () => {
        if (id === NEXT) {
            this.props.getDataForPage(this.state.current + 1);
            this.setState({ current: this.state.current + 1 });
        } else if (id === PREVIOUS) {
            this.props.getDataForPage(this.state.current - 1);
            this.setState({ current: this.state.current - 1 });
        }
    };
}

PaginationComponent.propTypes = {
    total: PropTypes.number,
    current: PropTypes.number,
    getDataForPage: PropTypes.func
};

export default PaginationComponent;



// WEBPACK FOOTER //
// ./src/components/commonComponents/paginationComponent/PaginationComponent.js